module.exports = __webpack_public_path__ + "img/fi-korean-food-400x263.a642916b.jpg";